import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { UserFriendlyError } from './model/Error'
import appStore from './store'
import { addMessage } from './store/message'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * (60 * 1000), // 2 mins
      gcTime: 10 * (60 * 1000), // 10 mins
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof UserFriendlyError) {
        appStore.dispatch(addMessage(error.getMessage()))
      } else {
        console.error(error)
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (error instanceof UserFriendlyError) {
        appStore.dispatch(addMessage(error.getMessage()))
      } else {
        console.error(error)
      }
    },
  }),
})
